import React from 'react';
import PropTypes from 'prop-types';
import Transactions from 'components/transactions/Transactions';
import TransactionFilterValues from 'components/transactions/TransactionFilterValues';
import TransactionBriefDetailsModal from 'components/transactions/TransactionBriefDetailsModal';

export default function CustomerTransactionsTab({ customerId }) {
  return (
    <>
      <TransactionFilterValues />
      <Transactions filterByCustomer={true} customerId={customerId} />
      <TransactionBriefDetailsModal />
    </>
  );
}

CustomerTransactionsTab.propTypes = {
  customerId: PropTypes.string.isRequired,
};
